import { render, staticRenderFns } from "./borrowBookDetail.vue?vue&type=template&id=616a1478&"
import script from "./borrowBookDetail.vue?vue&type=script&lang=js&"
export * from "./borrowBookDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports